import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOrderPlanningCustomerLookup extends Layout {
	sourceCustomers: DataSource;
	tableCustomers: Table;
}
